import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomsListCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomsListCmd.validationSchema()
  );

  constructor(readonly value: RoomsList) {
    JsonSchemaValidator.assert(RoomsListCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [],
      properties: {},
      additionalProperties: false
    };
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RoomsList {}
